import axios from "axios";

export const getTokensPrice = async () => {
  try {
    const response = await axios.get(
      "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=pulsex,tether-pulsechain,hex"
    );

    const tokens = response.data.reduce((result: any, token: any) => {
      result[token.symbol] = token.current_price;
      return result;
    }, {});

    return tokens;
  } catch (error) {
    throw new Error("Failed to retrieve price from Coingecko");
  }
};

export const getPrintPrice = async () => {
  try {
    const response = await axios.get(
      "https://api.dexscreener.com/latest/dex/pairs/pulsechain/0x2cb92b1e8B2fC53b5A9165E765488e17B38C26D3,0xF35F8Db9B6760799DB76796340AAcc69deA0C644,0xf808Bb6265e9Ca27002c0A04562Bf50d4FE37EAA"
    );

    const tokens = response.data.pairs.reduce((result: any, token: any) => {
      result[token.baseToken.symbol] = token.priceUsd;
      return result;
    }, {});

    return tokens;
  } catch (error) {
    throw new Error("Failed to retrieve price from Dex Screeener");
  }
};
